import React from 'react';
import { useTranslation } from 'react-i18next'; // useTranslation hook-ის იმპორტი
import Agitator from '../../../assets/images/Agitator.png';
import PistonPump from '../../../assets/images/PistonPump.png';
import ImpellerPump from '../../../assets/images/impellerpump.png';
import MohnoPump from '../../../assets/images/MohnoPump.png';
import Peristalticpump from '../../../assets/images/Peristalticpump.png';
import FrancescaPump from '../../../assets/images/FrancescaPump.png';
import Centrifugalpump from '../../../assets/images/Centrifugalpump.png';

function Pump() {
  const { t } = useTranslation(); // useTranslation hook-ის გამოყენება

  const products = [
    {
      name: t("Peristaltic Pump"),
      description: t(
        "The oenological agitator has been specially designed for handling and processes in the wine industry. It is both simple and efficient in its operation: it is assembled onto the tank’s ball valve, the shaft is inserted and activated with a switch. Engineers have wanted to produce a mobile model, specifically for small tanks. In short, an agitator with easy to use, advanced features, with high performance and used for a wide range of applications."
      ),
      image: Peristalticpump,
    },
    {
      name: t("Mohno Pump"),
      description: t(
        "These eccentric screw pumps are suitable for pumping liquids, wines, and crushed and destemmed grapes. The movement of the stainless steel rotor inside the non-toxic rubber stator creates a continuous flow, without any beating phenomena and with the utmost respect for the organoleptic features of the product."
      ),
      image: MohnoPump,
    },
 
    {
      name: t("Pistone Pump"),
      description: t(
        "Piston pumps are built around the concept of a reciprocating piston alternately sucking in low-pressure fluid then compressing and discharging the fluid to a high-pressure area. Piston pumps have many of the attributes required of a wine pump. They are self-priming and can provide variable flow rates efficiently."
      ),
      image: PistonPump,
    },
    {
      name: t("Rubber Impeller Pump"),
      description: t(
        "Flexible impeller pumps are a type of positive displacement pump, which can achieve high flow capacity. This type of wine pump can run at different speeds and accommodate differing viscosity types. These pumps are a popular choice for winemakers given their versatility and low maintenance requirements."
      ),
      image: ImpellerPump,
    },
    {
      name: t("Francesca Pump"),
      description: t(
        "Francesca Pompe Enologiche has revolutionized the cellar transfer system with the development of its first patent: the Francesca® pump which places innovative high-quality mechanics and dedicated electronics side by side rendering the work of wine experts and winemakers practical, accurate, and reliable."
      ),
      image: FrancescaPump,
    },
    {
      name: t("Agitator"),
      description: t(
        "The enological agitator has been specially designed for handling and processes the wine industry. It is both simple and efficient in its operation: it is assembled onto the tank’s ball valve, the shaft is inserted and activated with a switch. Engineers have wanted to produce a mobile model, specifically for small tanks. In short, an agitator with easy to use, advanced features, with high performance and used for a wide range of applications."
      ),
      image: Agitator,
    },
    {
      name: t("Centrifugal Pump"),
      description: t(
        "A centrifugal oenological pump is designed for efficient and gentle handling of liquids in winemaking. Its robust construction ensures durability while minimizing the risk of damage to delicate products. Ideal for transferring must, wine, or other liquids, it enhances productivity while maintaining the quality of the beverage."
      ),
      image: Centrifugalpump,
    },
  ];

  return (
    <div className='main-infocontainer'>
      {products.map((product, index) => (
        <div className='item-container' key={index}>
          <img src={product.image} alt={product.name} />
          <div className='text-info'>
            <h1>{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Pump;
